<template>
  <div class="user-profile">
    <h1>This is user profile</h1>
  </div>
</template>
